import { isNullOrEmptyString } from '@routes/List/utils'
import { context, getProductRow } from '@tools/wr-catalog-base'
import { get as safeGet } from 'lodash'

export const getDuration = (product) => {
  let duration = product.duration || 0
  if (product.rows) {
    const durationValue = product.rows.find((row) => row.label.replace('[CUSTOMER FACING]', '').trim() === 'Duration')
    if (durationValue && !isNaN(durationValue.control)) {
      duration = product.duration = Number(durationValue.control)
    }
  }
  if (product.serviceRateLabel && product.serviceRateLabel !== '') {
    const m = product.serviceRateLabel.match(/[\d,]+/)
    if (m.length) {
      const n = parseInt(m[0].replace(',', ''), 10)
      if (!isNaN(n)) {
        if (product.serviceRateLabel.toLowerCase().indexOf('day') !== -1) {
          duration = n * 8
        } else if (product.serviceRateLabel.toLowerCase().indexOf('week') !== -1) {
          duration = n * 40
        }
      }
    }
  }
  return duration
}

export const renderPrice = ({ props, defaultRender }) => {
  const regionName = context.utils.getRegionName()
  const pricingRow = (props.product.rows || []).find((r) => r.rowType === 'component:pricing')
  const points = context.utils.product.getPointPrice(props.product)
  const hours = getDuration(props.product)

  const display =
    !points && regionName
      ? !!pricingRow &&
        (isNullOrEmptyString(pricingRow.control.constants.find((cons) => cons.name === regionName)?.value)
          ? safeGet(pricingRow.control, 'schedule.serviceRateLabel')
          : 'Not available in Region')
      : !!(points || hours) && `${points} points | ${hours} hours`

  return defaultRender(display || ' ')
}

export const hasCustomizeThisPathTab = (product) => {
  return product.rows.find((r) => r.label.trim().toLowerCase() === 'customize this path')
}

export const isProductPrototype = (product) => {
  const row = getProductRow(product, 'label', 'Maturity Level')
  const isPrototype = row?.control?.label?.toLowerCase() === 'prototype'

  return isPrototype
}
